module.exports = __webpack_public_path__ + "img/RodriInsta_Final.8cba3ec5.jpg";